export const AGENCIES = [
  {
    id: "sistema-911",
    icon: "Siren",
    color: "red",
    name: { es: "Emergencias 9-1-1", en: "9-1-1 Emergencies" },
    desc: { es: "Vida en peligro, incendios, crímenes en curso. Disponible 24/7 en toda la isla.", en: "Life-threatening emergencies, fires, crimes in progress. Available 24/7 island-wide." },
    phone: "911",
    tel: "911",
  },
  {
    id: "nmead",
    icon: "ShieldAlert",
    color: "navy",
    name: { es: "NMEAD — Manejo de Emergencias", en: "NMEAD — Emergency Management" },
    desc: { es: "Negociado para el Manejo de Emergencias y Administración de Desastres. Activación de refugios y COE estatal.", en: "Bureau for Emergency Management and Disaster Administration. Shelter activation and state EOC." },
    phone: "787-724-0124",
    tel: "7877240124",
  },
  {
    id: "policia",
    icon: "Shield",
    color: "navy",
    name: { es: "Policía de Puerto Rico", en: "Puerto Rico Police" },
    desc: { es: "Cuartel general. Para emergencias en curso llame al 9-1-1.", en: "General headquarters. For ongoing emergencies call 9-1-1." },
    phone: "787-343-2020",
    tel: "7873432020",
  },
  {
    id: "bomberos",
    icon: "Flame",
    color: "red",
    name: { es: "Cuerpo de Bomberos de PR", en: "PR Fire Department" },
    desc: { es: "Incendios estructurales, rescates y materiales peligrosos. 91 estaciones en 6 zonas. Sede: Calle Loíza 2432, Punta Las Marías, San Juan.", en: "Structural fires, rescues and hazardous materials. 91 stations in 6 zones. HQ: Calle Loíza 2432, Punta Las Marías, San Juan." },
    phone: "787-343-2330",
    tel: "7873432330",
  },
  {
    id: "luma",
    icon: "Zap",
    color: "amber",
    name: { es: "LUMA Energy — Apagones", en: "LUMA Energy — Power Outages" },
    desc: { es: "Informe apagones, cables caídos y averías del sistema eléctrico.", en: "Report blackouts, downed lines and power system failures." },
    phone: "1-844-888-5862",
    tel: "18448885862",
  },
  {
    id: "aaa",
    icon: "Droplets",
    color: "navy",
    name: { es: "AAA — Averías de Agua", en: "AAA — Water Outages" },
    desc: { es: "Autoridad de Acueductos y Alcantarillados. Informe averías y localice oasis de distribución.", en: "Aqueduct and Sewer Authority. Report outages and locate water distribution points." },
    phone: "787-620-2482",
    tel: "7876202482",
  },
  {
    id: "familia",
    icon: "Users",
    color: "green",
    name: { es: "Departamento de la Familia", en: "Department of the Family" },
    desc: { es: "Protección de menores, adultos mayores y personas en situación de riesgo.", en: "Protection of minors, seniors and at-risk persons." },
    phone: "787-294-4900",
    tel: "7872944900",
  },
  {
    id: "linea-pas",
    icon: "HeartHandshake",
    color: "green",
    name: { es: "Línea PAS — ASSMCA", en: "PAS Line — ASSMCA" },
    desc: { es: "Apoyo emocional y prevención de suicidio, 24/7. También puede marcar 9-8-8.", en: "Emotional support and suicide prevention, 24/7. You can also dial 9-8-8." },
    phone: "1-800-981-0023",
    tel: "18009810023",
  },
  {
    id: "cruz-roja",
    icon: "Cross",
    color: "red",
    name: { es: "Cruz Roja Americana — PR", en: "American Red Cross — PR" },
    desc: { es: "Refugios, ayuda humanitaria y localización de familiares tras desastres.", en: "Shelters, humanitarian aid and family reunification after disasters." },
    phone: "787-759-7979",
    tel: "7877597979",
  },
  {
    id: "fema",
    icon: "Landmark",
    color: "navy",
    name: { es: "FEMA", en: "FEMA" },
    desc: { es: "Asistencia federal por desastre. Solicite ayuda individual tras declaraciones oficiales.", en: "Federal disaster assistance. Apply for individual aid after official declarations." },
    phone: "1-800-621-3362",
    tel: "18006213362",
  },
  {
    id: "envenenamiento",
    icon: "Biohazard",
    color: "amber",
    name: { es: "Centro de Envenenamiento", en: "Poison Control Center" },
    desc: { es: "Intoxicaciones, incluido monóxido de carbono por plantas eléctricas. 24/7.", en: "Poisoning, including carbon monoxide from generators. 24/7." },
    phone: "1-800-222-1222",
    tel: "18002221222",
  },
  {
    id: "nws",
    icon: "CloudSun",
    color: "navy",
    name: { es: "Servicio Nacional de Meteorología", en: "National Weather Service" },
    desc: { es: "Oficina de San Juan. Avisos oficiales de huracanes, inundaciones y marejadas.", en: "San Juan office. Official hurricane, flood and surf advisories." },
    phone: "787-253-4586",
    tel: "7872534586",
  },
  {
    id: "salud",
    icon: "Stethoscope",
    color: "green",
    name: { es: "Departamento de Salud", en: "Department of Health" },
    desc: { es: "Emergencias de salud pública, vacunación y orientación médica.", en: "Public health emergencies, vaccination and medical guidance." },
    phone: "787-765-2929",
    tel: "7877652929",
  },
  {
    id: "cem",
    icon: "Ambulance",
    color: "red",
    name: { es: "Cuerpo de Emergencias Médicas", en: "Medical Emergencies Corps" },
    desc: { es: "Ambulancias y respuesta médica pre-hospitalaria estatal.", en: "Ambulances and state pre-hospital medical response." },
    phone: "787-343-2550",
    tel: "7873432550",
  },
];
